// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("./Label.bs.js");
let DateIcon = require("./DateIcon.bs.js");
let ReactRender = require("../../../reason/utils/ReactRender.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");

function ShowingCard(props) {
  let __showNotes = props.showNotes;
  let badgeText = props.badgeText;
  let showNotes = __showNotes !== undefined ? __showNotes : true;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          Stdlib_Option.getOr(Stdlib_Option.map(props.dateIcon, dateIcon => JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(DateIcon.FromPlainDate.make, {
              date: dateIcon
            })
          })), null),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: props.date,
                className: "text-lg font-medium text-gray-800"
              }),
              JsxRuntime.jsx("div", {
                children: props.time,
                className: "text-lg"
              })
            ],
            className: "flex-1 flex flex-col justify-between gap-1.5"
          }),
          badgeText !== undefined ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Label.Neutral.make, {
                text: badgeText
              })
            }) : null
        ],
        className: "flex flex-row space-x-4 relative"
      }),
      ReactRender.ifTrue(JsxRuntime.jsx("div", {
        children: Stdlib_Option.getOr(props.notes, ""),
        className: "mt-4 text-gray-500"
      }), showNotes)
    ],
    className: "bg-white border border-gray-200 rounded-md p-3"
  });
}

let make = ShowingCard;

exports.make = make;
/* Label Not a pure module */
